
import ArrayUtils from "../util/ArrayUtils";
import NumberUtils from "../util/NumberUtils";
// 金额过滤器
function formatAmount(value) {
  return value ? NumberUtils.formatData(value) : "--";
}
// 金额6位小数过滤器
function formatPrice(value) {
  return NumberUtils.formatData(value, 6);
}
// 列表名称
function formatName(value, list, type, key) {
  if (!type) type = "id";
  if (!key) key = "name";
  return ArrayUtils.getItemBy(list, type, value)[key];
}

export default {
  formatAmount,
  formatPrice,
  formatName
}



// WEBPACK FOOTER //
// ./src/filters/index.js